<template>
    <div v-for="(article, index) in newsList" :key="article">
        <!--  Left image-->
        <div v-if="index % 2 == 0">
            <div class="container d-flex justify-content-center">
                <div class="card mb-3 w-75 p-2">
                    <div class="row g-0">
                        <div class="col-md-4 image-news-pc d-flex-custom align-items-center justify-content-center">
                            <img :src="'../images/news/' + article.slika" class="img-fluid rounded" width="200">
                        </div>
                        <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title text-uppercase fw-bold">{{article.naslov}}</h5>
                                <p class="card-text">{{article.opis}}</p>
                                <p class="card-text text-end"><small class="text-muted">{{article.datum}}</small></p>
                            </div>
                        </div>
                        <div class="col-md-4 image-news-phone align-items-center justify-content-center">
                            <img :src="'../images/news/' + article.slika" class="img-fluid rounded" width="200">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--  Right image-->
        <div v-else>
            <div class="container d-flex justify-content-center">
                <div class="card mb-3 w-75 p-2">
                    <div class="row g-0">
                        <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title text-uppercase fw-bold">{{article.naslov}}</h5>
                                <p class="card-text">{{article.opis}}</p>
                                <p class="card-text text-end"><small class="text-muted">{{article.datum}}</small></p>
                            </div>
                        </div>
                        <div class="col-md-4 d-flex align-items-center justify-content-center">
                            <img :src="'../images/news/' + article.slika" class="img-fluid rounded" width="200">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

let apiUrl = `https://www.nova.avtoprevoznistvo-topler.eu/api/news.php`;

export default {
    name: "News",
    data() {
        return {
            newsList: null
        };
    },
    mounted() {
    try {
      axios.get(apiUrl).then((response) => {
        this.newsList = response.data;
      });
    } catch (err) {
      throw new Error(err);
    }
  },

}
</script>